import { PlanningObject } from "pages/public/Planner/PlannerFlow.model";

export interface TripMaped {
  sortInfo: { price: number; duration: number; ecologic: number };
  departureTime: string;
  totalTime: string;
  price: string;
  ecologicSection: Array<{ icon: string; iconFill: string; size: string }>;
  trasportSection: any;
  hideDetail: boolean;
  tripDayPlanified: boolean;
  idRuta?: any;
  trip?: any;
  origenHour?:string
}

export interface PlanningObj extends PlanningObject {
    trip: 'OUTWARD' | 'RETURN'
}

export enum EAveTarifTypes {
  BASICO = "BASICO",
  ELIGE = "ELIGE",
  CONFORT = "CONFORT",
  PREMIUM = "PREMIUM",
  IDA_Y_VUELTA = "IDA_Y_VUELTA",
}
export interface IReturnTrainStateControlObject {
  isFromToTarifSelected: boolean;
  isTrainReturnSelected: boolean;
  trainReturnTarifSelected: string;
  trainTripCardInfo?: any;
  outwardTripPst?: any;
  tarifSelected?: any;
}
export interface RealPriceTag {
  price: number;
  text: string;
  type: string;
  id: string;
  shpCtx: string;
}

export interface Pricetag {
  price: number;
  text: string;
  type: string;
  id: string;
  shpCtx: string;
  isSilentCar: boolean;
}

export interface Line {
  icon: string;
  transportTypeString: string;
  size?: string;
  background?: string;
  text: string;
  backgroundcolor: string;
  color?: string;
  idx?: number, 
}

export interface Literals {
  action: string;
}

export interface Origin {
  name: string;
  type: string;
  id: string;
  extId: string;
  lon: number;
  lat: number;
  routeIdx: number;
  prognosisType: string;
  time: string;
  date: string;
}

export interface Destination {
  name: string;
  type: string;
  id: string;
  extId: string;
  lon: number;
  lat: number;
  routeIdx: number;
  prognosisType: string;
  time: string;
  date: string;
}

export interface JourneyDetailRef {
  ref: string;
}

export interface Stop {
  name: string;
  id: string;
  extId: string;
  routeIdx: number;
  lon: number;
  lat: number;
  depTime: string;
  depDate: string;
  depDir: string;
  arrTime: string;
  arrDate: string;
}

export interface Stops {
  Stop: Stop[];
}

export interface JourneyDetailRef2 {
  ref: string;
}

export interface ForegroundColor {
  r: number;
  g: number;
  b: number;
  hex: string;
}

export interface BackgroundColor {
  r: number;
  g: number;
  b: number;
  hex: string;
}

export interface Icon {
  foregroundColor: ForegroundColor;
  backgroundColor: BackgroundColor;
  res: string;
}

export interface OperatorInfo {
  name: string;
  nameS: string;
  nameN: string;
  nameL: string;
  id: string;
}

export interface Product {
  icon: Icon;
  operatorInfo: OperatorInfo;
  name: string;
  internalName: string;
  displayNumber: string;
  num: string;
  line: string;
  lineId: string;
  catOut: string;
  catIn: string;
  catCode: string;
  cls: string;
  catOutS: string;
  catOutL: string;
  operatorCode: string;
  operator: string;
  admin: string;
  matchId: string;
}

export interface Journey {
  Stops: Stops;
  JourneyDetailRef: JourneyDetailRef2;
  Product: Product;
  name: string;
  direction: string;
  trainNumber: string;
  trainCategory: string;
}

export interface Freq {
  journey: Journey[];
  waitMinimum: number;
  waitMaximum: number;
  alternativeCount: number;
}

export interface ForegroundColor2 {
  r: number;
  g: number;
  b: number;
  hex: string;
}

export interface BackgroundColor2 {
  r: number;
  g: number;
  b: number;
  hex: string;
}

export interface Icon2 {
  foregroundColor: ForegroundColor2;
  backgroundColor: BackgroundColor2;
  res: string;
}

export interface OperatorInfo2 {
  name: string;
  nameS: string;
  nameN: string;
  nameL: string;
  id: string;
}

export interface Product2 {
  icon: Icon2;
  operatorInfo: OperatorInfo2;
  name: string;
  internalName: string;
  displayNumber: string;
  num: string;
  line: string;
  lineId: string;
  catOut: string;
  catIn: string;
  catCode: string;
  cls: string;
  catOutS: string;
  catOutL: string;
  operatorCode: string;
  operator: string;
  admin: string;
  routeIdxFrom: number;
  routeIdxTo: number;
  matchId: string;
}

export interface Stop2 {
  name: string;
  id: string;
  extId: string;
  routeIdx: number;
  lon: number;
  lat: number;
  depTime: string;
  depDate: string;
  depDir: string;
  arrTime: string;
  arrDate: string;
}

export interface Stops2 {
  Stop: Stop2[];
}

export interface JourneyDetail {
  dayOfOperation: string;
  ref: string;
}

export interface Coordinate {
  order: number;
  lon: number;
  lat: number;
}

export interface GisRoute {
  coordinates: Coordinate[];
}

export interface Trip {
  Origin: Origin;
  Destination: Destination;
  JourneyDetailRef: JourneyDetailRef;
  Freq: Freq;
  JourneyStatus: string;
  Product: Product2[];
  Stops: Stops2;
  JourneyDetail: JourneyDetail;
  id: string;
  idx: number;
  name: string;
  number: string;
  category: string;
  type: string;
  reachable: boolean;
  direction: string;
  directionFlag: string;
  duration: string;
  dist: number;
  GisRoute: GisRoute;
}

export interface SilentCar {
  index: number;
  isSilent: boolean;
}

export interface Param {
  name: string;
  value: string;
}

export interface ExternalContent {
  content: string;
  text: string;
  contentType: string;
}

export interface Group {
  type: string;
  child: boolean;
}

export interface Ticket {
  param: Param[];
  externalContent: ExternalContent;
  name: string;
  price: number;
  cur: string;
  shpCtx: string;
  group: Group;
}

export interface Param2 {
  name: string;
  value: string;
}

export interface ReturnTrainList {
  ticket: Ticket;
  param: Param2[];
}

export interface FromToTrainTrip {
  returnTrainList: ReturnTrainList[];
  isFromToTrainTrip: boolean;
}

export interface IMappedDetailObject {
  idPst: string;
  tripId: string;
  departureDate: string;
  arrivalTime: string;
  departureTime: string;
  direction: string;
  icon: string;
  transportTypeString: string;
  isAproximetePriceElement: boolean;
  isCarTransport: boolean;
  isExternal: boolean;
  transport: boolean;
  frecuency: string;
  realPriceTag: RealPriceTag;
  pricetag: Pricetag;
  stops: string[];
  direct: boolean;
  showFooter: boolean;
  line: Line;
  showDrivingLicense: boolean;
  literals: Literals;
  pricePerTime: string;
  estimated: boolean;
  trip: Trip;
  silentCar: SilentCar;
  fromToTrainTrip: FromToTrainTrip;
}




interface Estacion {
  codigoEstacion: string;
  descripcionEstacion: string;
}

interface Horario {
  salida: string;
  salidaReal: string;
  llegada: string;
  llegadaReal: string;
  duracion: string;
  duracionReal: string;
}

interface Tramo {
  origen: Estacion;
  destino: Estacion;
  horario: Horario;
  lineaOrigen: string;
  lineaDestino: string;
  codigoTren: string;
  accesible: string;
}

interface Trayecto {
  origen: Estacion;
  destino: Estacion;
  horario: Horario;
  alerta: string | null;
  tramos: Tramo[];
}

export interface ITrainSchedules {
  trayectos: Trayecto[];
}